module.exports = __webpack_public_path__ + "img/logoShare.407ff566.png";